<div class="m-3 grid grid-cols-1 lg:grid-cols-2" *ngIf="currentDriver$ | async as currentDriver">
  <div>
    <div *ngIf="driverCutFormControl">
      <div class="text-lg font-bold pb-2">Driver Earnings</div>
      <div class="flex flex-col sm:flex-row items-center">
        <mat-form-field class="w-1/2">
          <mat-label>Load Earnings Percentage</mat-label>
          <input matInput [formControl]="driverCutFormControl" type="number" autocomplete="off" />
          <div matSuffix>%</div>
          <mat-hint *lohiEarningsProgramMember
            >{{ (authService.userInfo$ | async).companyName }} Earnings: {{ 100 - driverCutFormControl.value }}%
          </mat-hint>
        </mat-form-field>
        <div class="pl-3">
          <button (click)="updateDriverPercentage()" color="primary" mat-stroked-button>Save</button>
        </div>
      </div>
      <div class="text-gray-700 text-sm">
        Used to show the driver how much they can expect to earn with each load. Calculated as a percent of that load's
        revenue (less fuel surcharge).
        <ng-container *lohiFeatureFlag="'driverCutBrokerHelpText'">
          <ng-container *lohiRelationship="['broker', 'carrier']">{{ driverCutHelpAddition$ | async }}</ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div>
    <div *ngIf="driverTruckFormControl">
      <div class="text-lg font-bold pb-2">Truck</div>
      <div class="flex flex-col sm:flex-row items-center" *ngIf="trucks$ | async as trucks">
        <mat-form-field class="w-1/2">
          <mat-label>Assigned Truck</mat-label>
          <mat-select [formControl]="driverTruckFormControl">
            <mat-option *ngFor="let truck of trucks; trackBy: 'truckId' | trackByKey" [value]="truck.truckId"
              >{{ truck.truckName }}
              <ng-container *ngIf="truck.assignedTo">({{ truck.assignedTo }})</ng-container>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="pl-1 cursor-pointer" (click)="addTruckPrompt()">add_circle</mat-icon>
        <div class="pl-3">
          <button (click)="setTruckId()" color="primary" mat-stroked-button>Save</button>
        </div>
      </div>
      <div class="text-gray-700 text-sm">
        This driver's loads will always be assigned to this truck. They will no longer be able to edit their truck
        number in the mobile app on new loads.
      </div>
    </div>
  </div>
  <div class="mt-6">
    <div *ngIf="driverCDLFormControl">
      <div class="text-lg font-bold pb-2">CDL</div>
      <div class="flex flex-col sm:flex-row items-center">
        <mat-form-field class="w-1/2">
          <mat-label>CDL Number</mat-label>
          <input matInput [formControl]="driverCDLFormControl" autocomplete="off" />
          <mat-hint *lohiRelationship="'carrier'">Please contact support to change your CDL..</mat-hint>
        </mat-form-field>
        <div class="pl-3">
          <button (click)="updateDriverCDL()" color="primary" mat-stroked-button>Save</button>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-6">
    <div *ngIf="driverEmployeeIDFormControl">
      <div class="text-lg font-bold pb-2">Employee ID</div>
      <div class="flex flex-col sm:flex-row items-center">
        <mat-form-field class="w-1/2">
          <mat-label>Employee ID</mat-label>
          <input matInput [formControl]="driverEmployeeIDFormControl" autocomplete="off" />
        </mat-form-field>
        <div class="pl-3">
          <button (click)="updateDriverEmployeeId()" color="primary" mat-stroked-button>Save</button>
        </div>
      </div>
    </div>
  </div>
  <ng-container *lohiRelationship="'saas'">
    <div class="mt-6" *lohiFeatureFlag="'toggleDriverShiftBlocking'">
      <div *ngIf="driverAllowShiftBookingControl">
        <div class="text-lg font-bold pb-2">Allow Shift Booking</div>
        <div class="flex flex-col justify-center">
          <mat-slide-toggle
            color="primary"
            [formControl]="driverAllowShiftBookingControl"
            (change)="toggleShiftBooking($event)"
            >Allow Shift Booking
          </mat-slide-toggle>
        </div>
        <div class="text-gray-700 text-sm">
          If toggled off, the driver will not be able to book any shifts
          <ng-container *lohiFeatureFlag="'notifyDriverWarning'"
            >and they will receive a notification telling them that they are no longer able to book shifts
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *lohiEarningsProgramMember>
    <div class="mt-6" *lohiFeatureFlag="'removeTrailerFeeToggle'">
      <div *ngIf="removeTrailerFeeControl">
        <div class="text-lg font-bold pb-2">Deduct Trailer Fee From Estimated Earnings</div>
        <div class="flex flex-col justify-center">
          <mat-slide-toggle color="primary" [formControl]="removeTrailerFeeControl" (change)="toggleTrailerFee($event)"
            >Deduct Trailer Fee From Estimated Earnings
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="mt-6" *lohiFeatureFlag="'driverPasswordReset'">
    <div *ngIf="isDriver$ | async">
      <div class="text-lg font-bold pb-2">Reset Driver Password</div>
      <div class="flex flex-col">
        <mat-form-field class="w-full lg:w-1/2">
          <mat-label>New Password</mat-label>
          <input matInput [formControl]="newPasswordFormControl" type="password" />
        </mat-form-field>
        <mat-form-field class="w-full lg:w-1/2">
          <mat-label>Confirm Password</mat-label>
          <input matInput [formControl]="repeatPasswordFormControl" type="password" />
        </mat-form-field>
        <div class="text-gray-700">Password must be at least 6 characters long</div>
      </div>
      <div class="text-gray-700 text-sm flex justify-end">
        <button
          mat-stroked-button
          color="primary"
          (click)="resetPassword()"
          [disabled]="newPasswordFormControl.invalid"
        >
          Reset Password
        </button>
      </div>
    </div>
  </div>
  <!-- With grossWeightPermits on, certifications live on the Certifications/Permits tab. -->
  <ng-container *lohiFeatureFlag="'grossWeightPermits'; else certificationsCard"></ng-container>
  <ng-template #certificationsCard>
    <div class="mt-6 mr-2">
      <div class="text-lg font-bold pb-2">Driver Certifications</div>
      <mat-form-field class="w-full">
        <mat-label> Certifications</mat-label>
        <mat-select multiple [compareWith]="compareById" [formControl]="driverCertControl">
          <mat-select-trigger>
            <div class="flex items-center">
              {{ driverCertControl.value ? (certsMapping(driverCertControl.value) | joinWithAnd) : '' }}
            </div>
          </mat-select-trigger>
          <mat-option
            style="height: unset; line-height: 24px; font-size: 14px; white-space: normal"
            [value]="cert"
            *ngFor="let cert of certs$ | async; trackBy: 'id' | trackByKey"
          >
            <div class="flex flex-col p-1">
              <span class="font-semibold">{{ cert.name }}</span>
              <span>{{ cert.description }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex flex-row justify-end">
        <button color="primary" (click)="updateCerts()" mat-stroked-button>Update Driver Certifications</button>
      </div>
    </div>
  </ng-template>
  <div class="mt-6 mr-2" *lohiFeatureFlag="'lohiPay'">
    <ng-container *ngIf="isDriver$ | async">
      <div class="text-lg font-bold pb-2">Spending Limits</div>
      <mat-form-field class="w-full lg:w-1/2">
        <mat-label>Spending Limit</mat-label>
        <input matInput [formControl]="spendingLimitControl" type="text" lohiCurrencyInput autocomplete="off" />
      </mat-form-field>
      <div class="flex flex-row justify-between">
        <button color="warn" (click)="removeSpendingLimit()" mat-stroked-button>Remove Limit</button>
        <button color="primary" (click)="updateSpendingLimit()" mat-stroked-button>Update</button>
      </div>
    </ng-container>
  </div>
  <div class="mt-6 mr-2" *ngIf="driverDetail$ | async as driver">
    <div *ngIf="!driver.isClassicDriver">
      <div *ngIf="isDriver$ | async">
        <div class="text-lg font-bold pb-2">Reward Tier History</div>
        <div class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto h-35 md:h-75">
          <div
            *ngFor="let hist of driver.rewardTierHistory; trackBy: 'activeAt' | trackByKey"
            class="mb-2 p-1 rounded"
            [ngClass]="{
              'text-white': hist.name === 'Black' || hist.name === 'Silver' || hist.name === 'Blue',
              'bg-black': hist.name === 'Black',
              'bg-yellow-500': hist.name === 'Gold',
              'bg-gray-600': hist.name === 'Silver',
              'bg-blue-500': hist.name === 'Blue'
            }"
          >
            <div class="flex justify-between">
              <div class="flex-1">
                <span class="font-bold">{{ hist.activeAt | standardDate }}</span>
                <span class="ml-1">{{ hist.name }} - {{ 1 - hist.takeRate | percent: '0.0-2' }}</span>
              </div>
              <span *ngIf="hist.displayName">{{ hist.displayName }}</span>
              <span class="text-xs px-2 rounded-md border-2 text-right whitespace-nowrap"
                >{{ hist.points | number }} pts</span
              >
            </div>
            <div *ngIf="hist.details" class="italic">{{ hist.details }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-6 mr-2" *ngIf="driverDetail$ | async as driver">
    <div *ngIf="!driver.isClassicDriver">
      <div *ngIf="isDriver$ | async">
        <div class="text-lg font-bold pb-2">Tier Events</div>
        <div class="card-with-shadow flex flex-col bg-white rounded overflow-y-auto h-35 md:h-75">
          <div *ngFor="let tierEvent of driver.userTierEvent; trackBy: 'activeAt' | trackByKey">
            <div class="flex flex-col">
              <div class="flex flex-col border-t border-gray-600 p-2">
                <div class="flex justify-between">
                  <div class="text-gray-900">
                    {{ tierEvent.name }}
                  </div>
                  <div>
                    <span
                      class="text-xs px-2 py-1 rounded-md text-right whitespace-nowrap"
                      [ngClass]="tierEvent.points >= 0 ? 'bg-green-100' : 'bg-red-200'"
                      *ngIf="tierEvent.points != 0"
                      >{{ tierEvent.points | number }} pts</span
                    >
                    <span
                      class="text-xs px-2 py-1 rounded-md border-2 text-right whitespace-nowrap"
                      *ngIf="tierEvent.points === 0"
                      >{{ tierEvent.points | number }} pts</span
                    >
                  </div>
                </div>
                <span class="text-xs text-gray-600">{{ tierEvent.createdAt | standardDate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addTruck>
  <div mat-dialog-title>Add Truck</div>
  <div mat-dialog-content>
    <ng-container *ngIf="addingAsset$$ | async; else addAssetForm">
      <div class="flex items-center justify-center">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>
    <ng-template #addAssetForm>
      <mat-form-field class="w-full">
        <mat-label>Truck Number</mat-label>
        <input matInput #truckName autocomplete="off" class="uppercase" />
      </mat-form-field>
      <div class="flex justify-between">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-stroked-button (click)="addNewTruck(truckName.value)" [disabled]="!truckName.value">
          Add Truck
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>
